import { useLocation } from "react-router-dom";
import { usePreserveSearchParamsNavigate } from "../../../hooks/usePreserveSearchParamsNavigate.ts";
import {
  ANIMATE_TOOL,
  ANIMATE_TOOL_PATH,
  BRIEF_TOOL,
  BRIEF_TOOL_PATH,
  COPY_AD_TOOL,
  COPY_AD_TOOL_PATH,
  EDIT_ASSET_TOOL,
  EDIT_ASSET_TOOL_PATH,
  EDIT_IMAGE_TOOL,
  EDIT_IMAGE_TOOL_PATH,
  EDIT_IMAGE_WITH_PROMPT_TOOL,
  EDIT_IMAGE_WITH_PROMPT_TOOL_PATH,
  EDIT_SHAPE_TOOL,
  EDIT_SHAPE_TOOL_PATH,
  EDIT_TEXT_TOOL,
  EDIT_TEXT_TOOL_PATH,
  EXPAND_TOOL,
  EXPAND_TOOL_PATH,
  FILL_TOOL,
  FILL_TOOL_PATH,
  GENERATE_TOOL,
  GENERATE_TOOL_PATH,
  TRANSFER_TOOL,
  TRANSFER_TOOL_PATH,
  UPSCALE_TOOL,
  UPSCALE_TOOL_PATH,
  VARIATION_TOOL,
  VARIATION_TOOL_PATH,
} from "../../../routes.ts";
import type { Tool } from "../types.ts";

export const useSelectedTool = () => {
  // XXX: Since the selected tool is not stored in a state
  // the components that use it won't refresh when the tool changes.
  const selectedTool = getSelectedTool();
  const location = useLocation();
  const navigate = usePreserveSearchParamsNavigate();

  return {
    selectedTool,
    setSelectedTool: (tool: Tool | undefined) => {
      if (tool && tool !== selectedTool) {
        if (selectedTool) {
          navigate(location.pathname.replace(selectedTool, tool));
        } else {
          navigate(location.pathname + "/" + tool);
        }
      }
      if (!tool && selectedTool) {
        navigate(location.pathname.replace("/" + selectedTool, ""));
      }
    },
  };
};

// FIXME: it should be improved the tool's names can be in the uuids which can
//  create mismatch
const getSelectedTool: () => Tool | undefined = () =>
  window.location.pathname.includes(GENERATE_TOOL_PATH)
    ? GENERATE_TOOL
    : window.location.pathname.includes(TRANSFER_TOOL_PATH)
    ? TRANSFER_TOOL
    : window.location.pathname.includes(EDIT_IMAGE_WITH_PROMPT_TOOL_PATH)
    ? EDIT_IMAGE_WITH_PROMPT_TOOL
    : window.location.pathname.includes(VARIATION_TOOL_PATH)
    ? VARIATION_TOOL
    : window.location.pathname.includes(FILL_TOOL_PATH)
    ? FILL_TOOL
    : window.location.pathname.includes(UPSCALE_TOOL_PATH)
    ? UPSCALE_TOOL
    : window.location.pathname.includes(BRIEF_TOOL_PATH)
    ? BRIEF_TOOL
    : window.location.pathname.includes(EXPAND_TOOL_PATH)
    ? EXPAND_TOOL
    : window.location.pathname.includes(EDIT_TEXT_TOOL_PATH)
    ? EDIT_TEXT_TOOL
    : window.location.pathname.includes(EDIT_SHAPE_TOOL_PATH)
    ? EDIT_SHAPE_TOOL
    : window.location.pathname.includes(EDIT_IMAGE_TOOL_PATH)
    ? EDIT_IMAGE_TOOL
    : window.location.pathname.includes(EDIT_ASSET_TOOL_PATH)
    ? EDIT_ASSET_TOOL
    : window.location.pathname.includes(ANIMATE_TOOL_PATH)
    ? ANIMATE_TOOL
    : window.location.pathname.includes(COPY_AD_TOOL_PATH)
    ? COPY_AD_TOOL
    : undefined;
